import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromLoginDashboardActions from '../+state/actions/login-dashboard.actions';
import { AccountCookie } from '../models/login-dashboard.interfaces';

@Injectable({
  providedIn: 'root'
})
export class LoginDashboardFacade {
  constructor(private store: Store) {}

  storeInputValues(
    accountCookieValue: AccountCookie | null,
    isHipmunk: boolean
  ) {
    this.store.dispatch(
      fromLoginDashboardActions.StoreLoginDashboardInputValues({
        accountCookieValue,
        isHipmunk
      })
    );
  }

  loadDashboardLanding() {
    this.store.dispatch(fromLoginDashboardActions.LoadDashboardLanding());
  }
}
